import { render, staticRenderFns } from "./DatePickerTH.vue?vue&type=template&id=342b81b8&"
import script from "./DatePickerTH.vue?vue&type=script&lang=js&"
export * from "./DatePickerTH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports